module.exports = __webpack_public_path__ + "static/media/Drone_3.1f5caa95.PNG";